<template>
    <div class="step-container row">
        <div v-for="(item, index) in steps" :class="'col-'+Math.floor(12/steps.length)+(index<actual_step ? ' active' : '')">
            <div class="single-step-container">
                <div class="step-circle">
                    <span>{{index+1}}</span>
                </div>
                <div v-if="index+1<steps.length" class="line"></div>
                <div class="step-label">
                    {{item.label}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'wizard-steps',
        props: ['steps'],
        data() {
            return {
                actual_step: 0
            }
        },
        mounted() {
            if(this.steps && this.steps.length>0){
                for(let i=this.steps.length-1; i>=0; i--){
                    if(this.steps[i].active){
                        this.actual_step = i;
                        break;
                    }
                }
            }
        },
        methods: {
            
        }
    }
</script>
<style lang="scss">
    .step-container{
        /*min-width: 280px;*/
        > .col,
        > [class*="col-"] {
            text-align: center;
            color: #a0a6be;
            .single-step-container{
                width: fit-content;
            }
            .step-circle, .step-label{
                /*text-align: center;*/
            }
            .step-circle{
                position: relative;
                z-index: 10;
                background-color: white;
                border: 1px solid #a0a6be;
                border-radius: 1rem;
                width: 25px;
                height: 25px;
                line-height: 24px;
                margin: auto;
                font-weight: 600;
            }
            .line{
                width: 100%;
                height: 1px;
                border-bottom: 1px solid #a0a6be;
                position: absolute;
                left: 50%;
                top: 0%;
                margin-top: 12px;
            }
        }
        
        > .col.active,
        > [class*="col-"].active {
            .step-circle{
                background-color: #a0a6be;
                color: white;    
            }
            .line{
                border-bottom: 3px solid #a0a6be;
                position: absolute;
                left: 50%;
                top: 0%;
                margin-top: 11px;
            }
        }
    }
</style>
